!function webpackUniversalModuleDefinition(e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define([], t) : "object" == typeof exports ? exports["@wordpress/html-entities"] = t() : (e.wp = e.wp || {}, e.wp.htmlEntities = t());
}(self, function () {
  return function () {
    "use strict";

    var e = {};
    return function () {
      var t = e;
      var n;
      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.decodeEntities = function decodeEntities(e) {
        if ("string" != typeof e || -1 === e.indexOf("&")) return e;
        void 0 === n && (n = document.implementation && document.implementation.createHTMLDocument ? document.implementation.createHTMLDocument("").createElement("textarea") : document.createElement("textarea"));
        n.innerHTML = e;
        var t = n.textContent;
        return n.innerHTML = "", t;
      };
    }(), e;
  }();
});